import React from 'react';
import FormTextField from '../../components/FormTextField';
import FormSelect from '../../components/FormSelect';
import FormAutoCompleteCombo from '../../components/FormAutoCompleteCombo';
import { KEY_ENTER } from '../../constants';
import { func, array, string } from 'prop-types';
import map from 'lodash/map';

export const FilterByText = (props) => {
  const onFilterByNameKeyPress = (e) => {
    if (e.key === KEY_ENTER) {
      props.handleBlur();
    }
  };
  return (
    <FormTextField
      id={props.id}
      onKeyPress={onFilterByNameKeyPress}
      {...props}
    />
  )
};

FilterByText.propTypes = {
  handleBlur: func,
  id: string,
}

export const FilterBySelect = (props) => (
  <FormSelect
    {...props}
    noNoneOption
    noNativeSelect
  />
);

export const FilterByDeploymentType = (props) => (
  <FormAutoCompleteCombo
    {...props}
    id="key-store-filter-by-deployment-type"
    data-apim-test="key-store-filter-by-deployment-type"
    inputLabel={props.deploymentStatusFilterOptions[0].name}
    options={props.deploymentStatusFilterOptions}
    value={map(props.value, (status) => ({ ...status }))}
    onChange={(e, selectedValues) => props.handleChange(selectedValues)}
    noMargin
    hideHelper
    multiple
  />
);

FilterByDeploymentType.propTypes = {
  deploymentStatusFilterOptions: array,
  value: array,
  handleChange: func,
}